const API_URL = '/api/user/'

const setDateRange = async (date) => {
    return date;
}

const vendorService = {
    setDateRange,
}

export default vendorService;